import { ReactNode } from 'react'

import theme from 'theme_'
import { makePublicUrl } from 'app/utils/publicUrl'
import { H2 } from 'components/Typography'

import {
  HeaderContainer,
  SysMonContainer,
  SysMonInfoLine,
  SysMonTitle,
  SysMonCaptions,
  SysMonCaption,
} from './styles'

interface SysMonUnavailableProps {
  pageTitle: ReactNode
  title: ReactNode
  captions: string[]
}

const SysMonUnavailable = ({
  pageTitle,
  title,
  captions,
}: SysMonUnavailableProps) => {
  return (
    <>
      <HeaderContainer>
        <H2>{pageTitle}</H2>
      </HeaderContainer>
      <SysMonContainer>
        <img
          alt="System monitor is unavailable"
          src={makePublicUrl('images/systemMonitor/offline.svg')}
        />
        <SysMonInfoLine>
          <SysMonTitle color={theme.colors.duneWarmGrey}>{title}</SysMonTitle>
          <SysMonCaptions>
            {captions.map((message, idx) => {
              return <SysMonCaption key={idx}>{message}</SysMonCaption>
            })}
          </SysMonCaptions>
        </SysMonInfoLine>
      </SysMonContainer>
    </>
  )
}

export default SysMonUnavailable
